import React from 'react';
import moment from 'moment';
import Icon from 'src/components/Icon/Icon';
import { observer } from 'src/utils/mobx-react';
import { OpenapiProxyStaffFreebetCreditsResponse200Type } from 'src/api_openapi/generated/openapi_proxy_staff_freebet_credits';
import { Result } from 'src_common/common/mobx-utils/Resource';
import { formatAmountWithCurrency, CurrencyType } from 'src_common/common/amount/website-money/currency';

const defaultDateFormat = 'DD/MM/YY';

interface FreeBetsFormPropsType {
    freebetCredits: Result<OpenapiProxyStaffFreebetCreditsResponse200Type>
    handleShowModal: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
    currency: CurrencyType,
    permisionsAllowed: boolean
}

export const FreeBetsActiveTable = observer('FreeBetsActiveTable', ({ freebetCredits, currency, permisionsAllowed, handleShowModal }: FreeBetsFormPropsType) => {

    return (
        <div className='freebets__credits'>
            <h3>Current Free Bet Credits</h3>
            <table className='freebets__credits'>
                <thead>
                    <tr key='freebets__credits-header'>
                        <th>Date</th>
                        <th>Promotion / Source</th>
                        <th>Amount</th>
                        <th>Remove</th>
                    </tr>
                </thead>
                <tbody>
                    {freebetCredits.type === 'ready' ? freebetCredits.value.bonusCredits.sort(({id: idA},{id: idB})=> idB - idA).map(({ id, createdAt, promotionId, expiryDate, amount }) => (
                        <tr key={id}>
                            <td data-test='current-free-bet-credits-date'>{moment(createdAt).format(defaultDateFormat)}</td>
                            <td data-test='current-free-bet-credits-promotion/source'>
                                <span>{promotionId}</span>
                                <span className='small-text'>
                                    Expires:
                                    {moment(expiryDate).format(defaultDateFormat)}
                                </span>
                            </td>
                            <td data-test='current-free-bet-credits-amount'>{formatAmountWithCurrency(currency, $appState.configState.precision.newFromOld(amount))}</td>
                            <td className='align-center' data-test='current-free-bet-credits-remove-icon'>
                                {
                                    permisionsAllowed === true ?
                                        <span className='freebets__remove' data-value={id} onClick={handleShowModal} data-test='remove-icon'><Icon name='trashcan' /></span> : <span>Not Allowed</span>
                                }
                            </td>
                        </tr>
                    )) : null}
                </tbody>
            </table>
            {(freebetCredits.type === 'ready' && freebetCredits.value.bonusCredits.length === 0) || freebetCredits.type === 'error' ? <div className='freebets__info'>No free bet credits available</div> : null}

        </div>
    );
});
